import axios from 'axios'

const HOST_URL = 'https://api.ipify.org/?format=json'

export const getIp = async (): Promise<string> => {
  const data = await axios.get(HOST_URL)
  return data['data']['ip']
}
